<template>
  <div>
    <!-- Datatable hidden while data is loading -->
    <div v-if="!loading">
    <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2>Drivers</h2></v-toolbar-title>
      <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field>
    </v-toolbar>
      <!-- Datatable -->
      <v-data-table
          :headers="headers"
          :items="driversData"
          :search="search"
          class="elevation-1">

        <!-- Row action (edit/delete) -->
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>

      <br/>

      <!-- Load More button -->
      <v-btn v-on:click="loadMore" :disabled="lastPageReached" class="primary">Load More</v-btn>

      <!-- Driver Dialog (create/edit) -->
      <v-dialog
          v-model="dialog"
          max-width="500px"
      >
        <CreateDialog
            v-bind:close-function="closeDialog"
            v-bind:form-title="dialogTitle"
            v-bind:item="editDriver"
            v-bind:save-function="saveDriver" />
      </v-dialog>

      <!-- Delete confirmation dialog -->
      <v-dialog v-model="deleteDialog" max-width="500px">
        <DeleteDialog
          v-bind:close-delete="closeDialog"
          v-bind:delete-item-confirm="deleteDriver"></DeleteDialog>
      </v-dialog>
    </div>

    <!-- Display loader when fetching data -->
    <div v-if="loading">
      <Loading/>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import CreateDialog from "@/components/drivers/CreateDialog";
import DeleteDialog from "@/components/drivers/DeleteDialog";
import { getFirestore, getDocs, collection, setDoc, deleteDoc, doc, query, limit, startAfter, where, addDoc, orderBy } from 'firebase/firestore';
const db = getFirestore();

async function cleanupAfterDialog(context) {
  context.editDriver = {};
  context.query = null;
  context.driversData = [];
  await context.loadMore();
  context.closeDialog();
}

export default {

  name: 'Drivers',
  components: { DeleteDialog, CreateDialog, Loading },

  data() {
    return {
      dialog: false,
      dialogTitle: 'New Driver',
      deleteDialog: false,
      editDriver: {},
      headers: [
        { text: 'Name', value: 'firstName' },
        { text: 'Surname', value: 'lastName' },
        { text: 'Email', value: 'emailAddress' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Reg Number', value: 'regNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      driversData: [],
      options: {
        page: 1,
        pageSize: 100
      },
      loading: false,
      query: null,
      lastVisible: null,
      search: '',
      lastPageReached: false
    }
},

methods: {
  closeDialog() {
    this.dialog = false;
    this.deleteDialog = false;
    this.dialogTitle = 'New Driver';

    this.$nextTick(() => {
      Object.assign(this.editDriver, {});
    })
  },

  async saveDriver() {
    if (!this.editDriver.id) {
      addDoc(collection(db, 'users'))
      .then( async () => {
        await cleanupAfterDialog(this);
      });     
    } else {
      setDoc(doc(db, 'users', this.editDriver.id),this.editDriver, {merge: true})
      .then( async () => {
        await cleanupAfterDialog(this);
      });      
    }
    this.dialog = false;
  },
  async deleteDriver() {
    deleteDoc(doc(db, 'users', this.editDriver.id))
    .then( async () => {
      await cleanupAfterDialog(this);
    });     
  },
  async editItem(drivers) {
    Object.assign(this.editDriver, drivers);
    this.dialogTitle = "Edit Driver";
    this.dialog = true;
  },
  async deleteItem(drivers) {
    Object.assign(this.editDriver, drivers);
    this.deleteDialog = true;
  },
  mapData(driver, driverId) {
    return {
      id: driverId,
      firstName: driver.firstName,
      lastName: driver.lastName,
      emailAddress: driver.emailAddress,
      mobile: driver.mobile,
      regNumber: driver.regNumber ? driver.regNumber : ''
    }
  },
  async getNextData(options) {
    this.loading = true;
    this.options = options;
    const { pageSize } = options;
    if (!this.query) {
      this.query = query(collection(db, 'users'), where('scope', '==', 'driver'), orderBy('firstName'), limit(pageSize));
    }

    try {
      const currentQuery = await getDocs(this.query);
      this.lastVisible = currentQuery.docs[currentQuery.docs.length - 1];

      currentQuery.forEach((res) => {
        this.driversData.push(this.mapData(res.data(), res.id));
      });
      if (currentQuery.size < pageSize) {
        this.lastPageReached = true;
      }
      this.query = query(collection(db, 'users'), where('scope', '==', 'driver'), orderBy('firstName'), startAfter(this.lastVisible), limit(pageSize));
      this.loading = false;
    } 
    catch (error) {
      console.log(error);
      this.loading = false;
    }

    },
    async loadMore() {
      await this.getNextData(this.options);
    }
  },
  async mounted() {
    if (this.driversData.length === 0 && this.loading === false) {
      this.loadMore();
    }
  }
}

</script>

<style scoped>


</style>